import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { SharedButton } from "components/shared/Buttons/SharedButton";
import { Typography } from "components/shared/Typography";
import { DEFAULT_PAGE_PATH } from "routes/paths";

const ErrorElement = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100vh"
    >
      <Typography variant="h4">{t("errors.something_went_wrong")}</Typography>
      <SharedButton href={`/${DEFAULT_PAGE_PATH}`}>{t("buttons.go_to_home")}</SharedButton>
    </Stack>
  );
};

export default ErrorElement;
